<fgb-banner [pageTitle]="'auction.page.title' | translate" />
<fgb-page-header [pageTitle]="'featured.rewards.page.title'" [backButtonLink]="'/'" />

<fgb-mixed-loyalty-nav></fgb-mixed-loyalty-nav>

<div class="container">
  <fgbcl-auction-list></fgbcl-auction-list>
</div>
